import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../Util/Session/session.service';
import { Router } from '@angular/router';
import { SupportTicketService } from '../Model/Support/support-ticket.service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClientTicketFormComponent } from '../client-ticket-form/client-ticket-form.component';
import { CommonService } from '../Model/Common/common.service';
import { EmployeeRegistrationService } from '../Model/EmployeeRegistration/employee-registration.service';

@Component({
  selector: 'app-client-assigned-tickets',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgSelectModule, DataTablesModule, NgbModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './client-assigned-tickets.component.html',
  styleUrl: './client-assigned-tickets.component.scss'
})
export class ClientAssignedTicketsComponent {

  isDisabled: boolean = false;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  constructor(
    private common: CustomDateParserFormatter,
    private modalService: NgbModal,
    private session: SessionService,
    private support: SupportTicketService,
    private commonservice: CommonService,
    private employeeRegistration: EmployeeRegistrationService,
  ) {
    this.user = session.GetUserDetails();
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      searching: true,
      pageLength: 50,
      lengthMenu: [5, 10, 25, 50, 100],
      processing: true,
      lengthChange: true,
      language: {
        searchPlaceholder: 'Search...',
      },
    }

    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    const addZero = month > 9 ? '' : '0';
    const monthNumber = addZero + month;
    this.selectedMonth = year + "-" + monthNumber;
    this.curDate();
    this.CountData();
    this.getData();
    this.ESS_AdditionalFillCombo();
    this.ComboLoad2('Branch');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  SupportData: any[] = [];

  Filter = {
    BranchID: [],
    ClientID: [],
    SiteOwnerID: [],
    SiteID: []
  }

  showFilter: boolean = true;
  isCollapsed: boolean = true;
  showDate: boolean = false;
  TicketStatus: any = 'Assigned';
  FromDate: any = null;
  FromDateObj: any = null;
  ToDate: any = null;
  ToDateObj: any = null;
  selectedMonth: any = null;
  startFromDate: any = null;
  startToDate: any = null;
  ComplaintType = null;
  user = {} as any;
  TableData: any[] = [];
  ComplaintTypes: any[] = [];
  TicketStatusLoad: any[] = [{ value: 'Open' }, { value: 'Assigned' }, { value: 'Resolved' }, { value: 'Closed' }, { value: 'All' }];

  Total: any = 0;
  Close: number = 0
  Open: number = 0
  Assigned: number = 0
  Resolved: number = 0

  Count: any[] = []
  globalTotal: number = 0
  globalOpen: number = 0
  globalClose: number = 0
  globalAssign: number = 0
  globalResolved: number = 0

  ComboLoad2(Combotype: String) {
    this.isDisabled = true;
    if (true || (Combotype == 'Region') ||
      (Combotype == 'Branch') ||
      (Combotype == 'Client' && this.Filter.BranchID.length > 0) ||
      (Combotype == 'Site' && this.Filter.ClientID.length > 0) ||
      (Combotype == 'SiteOwner')) {
      this.support.ComboLoad({
        'SelectType': Combotype,
        'BranchId': this.Filter.BranchID.toString(),
        'ClientId': this.Filter.ClientID.toString(),
        'SiteId': this.Filter.SiteID.toString(),
        //'SupervisorId': this.Filter.SiteOwnerID.toString(),
        'UserId': this.user.UserId,
      }).subscribe({
        next: (response) => {
          if (Combotype == 'Branch') {
            this.Branchs = response.Table;
          } else if (Combotype == 'Client') {
            this.Clients = response.Table;
          } else if (Combotype == 'Site') {
            this.Sites = response.Table;
          }
          this.isDisabled = false;
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.isDisabled = false;
    }
  }

  onchange(type: string) {
    if (type === 'ComplaintType') {
      this.SupportData = Object.values([]);
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
    } else if (type === 'Status') {
      this.SupportData = Object.values([]);
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
    } else if (type === 'Date') {
      this.SupportData = Object.values([]);
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
    } else if (type === 'Branch') {
      this.SupportData = Object.values([]);
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
      this.Filter.ClientID = []
      this.Clients = [];
      this.Filter.SiteID = [];
      this.Sites = []
    } else if (type === 'Client') {
      this.SupportData = Object.values([]);
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
      this.Filter.SiteID = [];
      this.Sites = []
    } else if (type === 'site') {
      this.SupportData = Object.values([]);
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
    } else if (type === 'supervisor') {
      this.SupportData = Object.values([]);
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      //   this.dtTrigger.next(null);
      // });
    }
  }

  curDate() {
    const currentDate = new Date();
    const FromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const ToDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const formatDate = (date: Date) => ({
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    });
    this.FromDate = formatDate(FromDate);
    this.ToDate = formatDate(ToDate);

    if (!this.showDate) {
      this.FromDateObj = this.common.format(this.FromDate);
      this.ToDateObj = this.common.format(this.ToDate);
    } else {
      this.FromDateObj = this.convertToStartDate(this.selectedMonth);
      this.ToDateObj = this.convertToEndDate(this.selectedMonth);
    }
  }

  convertToEndDate(input: any) {
    let [year, month] = input.split('-');
    const day = new Date(year, month, 0).getDate();
    month = this.common.month[Number(month) - 1];
    return `${day} ${month} ${year}`
  }

  convertToStartDate(input: any) {
    let [year, month] = input.split('-');
    month = this.common.month[Number(month) - 1];
    return `01 ${month} ${year}`
  }

  getData() {
    if (!this.showDate) {
      this.FromDateObj = this.common.format(this.FromDate);
      this.ToDateObj = this.common.format(this.ToDate);
    } else {
      this.FromDateObj = this.convertToStartDate(this.selectedMonth);
      this.ToDateObj = this.convertToEndDate(this.selectedMonth);
    }

    const Detail = {
      SelectType: 'W',
      Tr_LoginMasterId: 0,
      UserId: this.user.UserId,
      Status: this.TicketStatus,
      FromDate: this.FromDateObj,
      ToDate: this.ToDateObj,
      BranchId: this.Filter.BranchID.toString(),
      ClientId: this.Filter.ClientID.toString(),
      SiteId: this.Filter.SiteID.toString(),
      SiteSupervisorId: this.Filter.SiteOwnerID.toString(),
      ESS_ClientPortalComplaintTypeId: this.ComplaintType,
      ESS_ClientPortalHelpDeskRequestId: 0,
      ClientPortalHelpDeskUserType: 'Admin'
    }
    this.isDisabled = true;
    this.support.ClientPortal_HelpDeskRequest(Detail).subscribe({
      next: (data) => {
        this.SupportData = Object.values(data.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.Open = this.SupportData.filter(item => item.Status.toLowerCase() === 'open').length;
        this.Close = this.SupportData.filter(item => item.Status.toLowerCase() === 'closed').length;
        this.Assigned = this.SupportData.filter(item => item.Status.toLowerCase() === 'assigned').length;
        this.Resolved = this.SupportData.filter(item => item.Status.toLowerCase() === 'resolved').length;
        // this.CountData('All');
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  CountData() {
    // this.SupportData = [];
    if (!this.showDate) {
      this.FromDateObj = this.common.format(this.FromDate);
      this.ToDateObj = this.common.format(this.ToDate);
    } else {
      this.FromDateObj = this.convertToStartDate(this.selectedMonth);
      this.ToDateObj = this.convertToEndDate(this.selectedMonth);
    }

    const Detail = {
      SelectType: 'W',
      Tr_LoginMasterId: 0,
      UserId: this.user.UserId,
      Status: 'All',
      // FromDate: this.FromDateObj,
      // ToDate: this.ToDateObj,
      FromDate: null,
      ToDate: null,
      BranchId: this.Filter.BranchID.toString(),
      ClientId: this.Filter.ClientID.toString(),
      SiteId: this.Filter.SiteID.toString(),
      SiteSupervisorId: this.Filter.SiteOwnerID.toString(),
      ESS_ClientPortalComplaintTypeId: this.ComplaintType,
      ESS_ClientPortalHelpDeskRequestId: 0,
      ClientPortalHelpDeskUserType: 'Admin'
    }
    this.isDisabled = true;
    this.support.ClientPortal_HelpDeskRequest(Detail).subscribe({
      next: (data) => {
        this.Count = data.Table;
        if (this.Count.length > 0) {
          this.globalTotal = this.Count.length;
          this.globalOpen = this.Count.filter(item => item.Status.toLowerCase() === 'open').length;
          this.globalAssign = this.Count.filter(item => item.Status.toLowerCase() === 'assigned').length;
          this.globalClose = this.Count.filter(item => item.Status.toLowerCase() === 'closed').length;
          this.globalResolved = this.Count.filter(item => item.Status.toLowerCase() === 'resolved').length;
        }
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  onEditClick(element: any) {
    const modalRef = this.modalService.open(ClientTicketFormComponent, { centered: true, backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.InputData = element;
    modalRef.componentInstance.Status = 'Resolved';
    modalRef.result.then((result) => {
      if (result) {
        this.SupportData = [];
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.getData();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  viewfile(filename: any) {
    window.open(this.commonservice.CompanyParameterValue.HTTPSDownloadLink + '/' + 'ClientPortalHelpdesk' + '/' + filename, '_blank');
  }

  clear() {
    this.SupportData = Object.values([]);
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'ClientPortalComplaintType',
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.ComplaintTypes = response.Table
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}